import { render, staticRenderFns } from "./PlatformTab.vue?vue&type=template&id=cba79e52&scoped=true"
import script from "./PlatformTab.vue?vue&type=script&lang=js"
export * from "./PlatformTab.vue?vue&type=script&lang=js"
import style0 from "./PlatformTab.vue?vue&type=style&index=0&id=cba79e52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba79e52",
  null
  
)

export default component.exports